// Pieces of a showroom entry shared by its preview card and the full entry.

// The fields every entry has; they're rendered by the views themselves rather
// than as generic label/value pairs.
export const specialFields = [
  "title",
  "upload",
  "coverImage",
  "tags",
  "type",
  "description",
];

const textFieldTypes = ["multiLine", "singleLine", "selection"];

// Non-special fields come back from the API as `{ data, label, type }`.
type LabelledField = { data?: string; label?: string; type?: string };

type OtherFormFieldsProps = {
  formData: Record<string, unknown>;
  styles?: {
    mainInfoCol?: string;
    label?: string;
    fieldValue?: string;
  };
};

/**
 * The entry's spark-specific text fields as label/value sections.
 */
export const OtherFormFields = ({
  formData,
  styles = {},
}: OtherFormFieldsProps) =>
  Object.entries(formData).map(([fieldKey, value]) => {
    const field = value as LabelledField;
    if (
      specialFields.includes(fieldKey) ||
      !field.data ||
      !textFieldTypes.includes(field.type ?? "")
    ) {
      return null;
    }
    return (
      <section
        className={styles.mainInfoCol}
        key={fieldKey}
        aria-labelledby={`label-${fieldKey}`}
      >
        <h2 id={`label-${fieldKey}`} className={styles.label}>
          {field.label}
        </h2>
        <p className={styles.fieldValue}>{field.data}</p>
      </section>
    );
  });
